module.exports = __webpack_public_path__ + "static/media/Gilroy-Medium.d8ee4539.ttf";